import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [procurementOpen, setProcurementOpen] = useState(false);
  return <header className="bg-white border-b border-gray-border sticky top-0 z-50" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4" data-id="element-259">
        <div className="flex items-center justify-between h-20" data-id="element-260">
          <Link to="/" className="flex items-center gap-3" data-id="element-261">
            <img src="https://cdn.magicpatterns.com/uploads/dUQRpLPA28c7QtfR6xGyBP/Logo.png" alt="African Union Commission" className="w-12 h-12 object-contain" data-id="element-262" />
            <div data-id="element-263">
              <div className="font-serif text-xl font-bold" style={{
              color: '#8B1A2C'
            }} data-id="element-264">
                African Union
              </div>
              <div className="text-sm text-gray-600" data-id="element-265">Commission</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-id="element-266">
            <Link to="/" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-267">
              Home
            </Link>
            <Link to="/about" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-268">
              About
            </Link>
            <Link to="/projects" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-269">
              Projects
            </Link>
            <Link to="/bids" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-270">
              Bids & Tenders
            </Link>

            <div className="relative" onMouseEnter={() => setProcurementOpen(true)} onMouseLeave={() => setProcurementOpen(false)} data-id="element-271">
              <button className="flex items-center gap-1 text-charcoal hover:text-au-green transition-colors font-medium py-2" data-id="element-272">
                Procurement
                <ChevronDownIcon size={16} data-id="element-273" />
              </button>

              {procurementOpen && <div className="absolute top-full left-0 pt-2 w-56 z-50" data-id="element-274">
                  <div className="bg-white rounded-lg shadow-lg border border-gray-border py-2" data-id="element-275">
                    <Link to="/procurement/annual-plan" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-276">
                      Annual Plan
                    </Link>
                    <Link to="/procurement/contract-awards" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-277">
                      Contract Awards
                    </Link>
                    <Link to="/procurement/unsuccessful-bids" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-278">
                      Unsuccessful Bids
                    </Link>
                    <Link to="/procurement/manual" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-279">
                      Procurement Manual
                    </Link>
                    <Link to="/procurement/supplier-registration" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-280">
                      Expression of Interest (EOI)
                    </Link>
                  </div>
                </div>}
            </div>

            <Link to="/contact" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-281">
              Contact
            </Link>
          </nav>

          <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-282">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-283" /> : <MenuIcon size={24} data-id="element-284" />}
          </button>
        </div>

        {mobileMenuOpen && <nav className="lg:hidden py-4 border-t border-gray-border" data-id="element-285">
            <Link to="/" className="block py-2 hover:text-au-green transition-colors" data-id="element-286">
              Home
            </Link>
            <Link to="/about" className="block py-2 hover:text-au-green transition-colors" data-id="element-287">
              About
            </Link>
            <Link to="/projects" className="block py-2 hover:text-au-green transition-colors" data-id="element-288">
              Projects
            </Link>
            <Link to="/bids" className="block py-2 hover:text-au-green transition-colors" data-id="element-289">
              Bids & Tenders
            </Link>
            <div className="py-2" data-id="element-290">
              <div className="font-medium mb-2" data-id="element-291">Procurement</div>
              <Link to="/procurement/annual-plan" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-292">
                Annual Plan
              </Link>
              <Link to="/procurement/contract-awards" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-293">
                Contract Awards
              </Link>
              <Link to="/procurement/unsuccessful-bids" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-294">
                Unsuccessful Bids
              </Link>
              <Link to="/procurement/manual" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-295">
                Procurement Manual
              </Link>
              <Link to="/procurement/supplier-registration" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-296">
                Expression of Interest (EOI)
              </Link>
            </div>
            <Link to="/contact" className="block py-2 hover:text-au-green transition-colors" data-id="element-297">
              Contact
            </Link>
          </nav>}
      </div>
    </header>;
}